import React, { Fragment } from "react";
import Header from "../Header/header";
import Sidebar from "../Sidebar/sidebar";
import { Outlet } from "react-router-dom";

export default function EasyArticles() {
  return (
    <Fragment>
      <Header />
      <Sidebar />
      <Outlet />
    </Fragment>
  );
}
